import { createContext } from 'react';

/**
 * Lets a page tell virtualized lists what scrolls, so they don't have to guess.
 *
 * - undefined (no provider): the list works it out itself (page scroll on phones, the nearest
 *   scrollable ancestor on larger screens).
 * - WINDOW_SCROLL: the page itself scrolls.
 * - an element: that element is the scroller (e.g. the main panel, or the profile container).
 * - null: a provider exists but its element isn't ready yet; the list waits.
 */
export const WINDOW_SCROLL = 'window';
export const ScrollParentContext = createContext(undefined);
